<page-layout>
  <header color="primary">
  <header-content>
    <div>
      <h1>Betingelser for brug af {{ windowService.getHostname() }}</h1>
      <h2>Gældende fra X. måned 2023</h2>
    </div>
  </header-content>
  </header>

  <main></main>

  <footer color="primary">
    <footer-content></footer-content>
  </footer>
</page-layout>
